import type { ToasterProps } from "sonner";

import { Toaster } from "../primitives/sonner";

/**
 * Mount `<ColocaToaster />` once in the app root to enable toast notifications. Do not mount it more than
 * once.
 *
 * To fire toasts from anywhere in the app, use `colocaToast` from `@/shared/utils/toast` — never import
 * `toast` from `"sonner"` directly.
 *
 * @summary single mount point for all toast notifications — place in app root only
 */
export function ColocaToaster(props: ToasterProps) {
  return <Toaster position="top-right" richColors={true} {...props} />;
}
